/*
 * Winy Mind Pvt. Ltd.
 * Created by suraj on 09/09/24, 5:57 pm
 * Copyright (c) 2024 . All rights reserved.
 * Last modified 09/09/24, 5:57 pm
 */

package tta.destinigo.talktoastro.feature_call_consultation.timer

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

class MyCoroutineCountDownTimer(
    private val timeInSeconds: Long,
    private val onComplete: () -> Unit,
    private val onTick: (remainingTime: String, elapsedTime: String) -> Unit
) {

    companion object {
        private const val INTERVAL_TIME = 1000L
        private const val TAG = "VoIPCallService"
    }

    private var countdownJob: Job? = null

    fun startTime() {

        countdownJob = CoroutineScope(Dispatchers.Main).launch {
            var timeLeft = timeInSeconds

            while (timeLeft > 0) {
                // Calculate remaining and elapsed time
                val elapsedMillis = timeInSeconds - timeLeft
                val formattedRemaining = formatTime(timeLeft)
                val formattedElapsed = formatTime(elapsedMillis)

                // Pass formatted times to the callback
                onTick.invoke(formattedRemaining, formattedElapsed)

                delay(INTERVAL_TIME)
                timeLeft -= INTERVAL_TIME
            }
            // Final callback when complete
            onComplete.invoke()
        }
    }

    fun stopTimer() {
        countdownJob?.cancel()
        countdownJob = null
    }
}

